import { Checkbox as MuiCheckbox } from '@mui/material';
import React, { FC } from 'react';

import {
  CheckedIcon,
  NonCheckedIcon,
  IndeterminateIcon
} from './Checkbox.parts';
import { CheckboxProps } from './Checkbox.types';

export const Checkbox: FC<CheckboxProps> = (props) => {
  return (
    <MuiCheckbox
      icon={<NonCheckedIcon />}
      checkedIcon={<CheckedIcon />}
      indeterminateIcon={<IndeterminateIcon />}
      {...props}
    />
  );
};
